import MobileCybersourcePaymentContainer from './MobileCybersourcePaymentContainer';

export default MobileCybersourcePaymentContainer;
